import React, {useEffect, useState} from 'react'
import {Formik, Form, Field, ErrorMessage, useFormikContext} from 'formik'
import * as Yup from 'yup'

import {
    createPanelDopItem,
    updatePanelDopItem,
    getPanelDopItem,
} from '../../api/paneliDop'

import {DigitalniDopItemValues} from '../../models/DigitalniDopModel'
import {useNavigate} from 'react-router-dom'
// 👉 replace with your toast
import notifyToast from '../../components/Toast/Toast'
import {toast, ToastContainer} from 'react-toastify'
import {useParams} from 'react-router-dom'
interface Props {
    id?: number
    onSuccess?: () => void
}

const validationSchema = Yup.object().shape({
    Naziv: Yup.string().required('Naziv je obavezan'),
    NazivEng: Yup.string().required('Naziv Engl. je obavezan'),
    NazivDe: Yup.string().nullable(),
    NazivEs: Yup.string().nullable(),
    NazivSl: Yup.string().nullable(),
    Mjera: Yup.string().nullable(),
    Standard: Yup.string().nullable(),
    Numeracija: Yup.string().nullable(),
})

const initialValues: DigitalniDopItemValues = {
    Naziv: '',
    NazivEng: '',
    NazivDe: '',
    NazivEs: '',
    NazivSl: '',
    Mjera: '',
    Standard: '',
    Numeracija: '',
}

const DigitalniDopStavkeDetails: React.FC<Props> = ({onSuccess}) => {
    const [loading, setLoading] = useState(false)
    const [formValues, setFormValues] = useState(initialValues)
    const navigate = useNavigate()
    const {id: routeId} = useParams()
    const parsedId = routeId ? Number(routeId) : undefined
    /**
     * LOAD DATA (edit mode)
     */
    useEffect(() => {
        if (!parsedId) return

        const fetchData = async () => {
            try {
                setLoading(true)

                const response = await getPanelDopItem(parsedId)

                if (response.data?.success) {
                    setFormValues(response.data.data)
                }
            } catch (error) {
                notifyToast(false, 'Greška prilikom učitavanja')
            } finally {
                setLoading(false)
            }
        }

        fetchData()
    }, [parsedId])

    /**
     * SUBMIT
     */
    const handleSubmit = async (
        values: DigitalniDopItemValues,
        {setSubmitting}: any
    ) => {
        try {
            setSubmitting(true)

            let response

            if (parsedId) {
                response = await updatePanelDopItem(parsedId, values)
            } else {
                response = await createPanelDopItem(values)
            }

            if (response.data?.success) {

                notifyToast(true, 'Uspješno sačuvano')

                if (!parsedId) {
                    setFormValues(initialValues)
                }


                onSuccess && onSuccess()
                setTimeout(() => {
                    navigate(-1)
                }, 2000)
            } else {
                notifyToast(false, 'Greška prilikom snimanja')
            }
        } catch (error) {
            notifyToast(false, 'Server greška')
        } finally {
            setSubmitting(false)
        }
    }

    if (loading) {
        return <div className='text-center p-10'>Učitavanje...</div>
    }

    return (

        <div className='card mb-5 mb-xl-10'>
            <ToastContainer/>
            <div className='card-header border-0'>
                <div className='card-title'>
                    <h3 className='fw-bolder'>📄 Digitalni DOP Stavka Dodaj</h3>
                </div>
            </div>

            <div className='card-body'>

                <Formik
                    enableReinitialize
                    initialValues={formValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({isSubmitting}) => (
                        <div className='row'>

                            <Form className='card col-6 p-5'>

                                <h4 className='mb-5'>
                                    {parsedId ? 'Uredi stavku' : 'Nova stavka'}
                                </h4>

                                {/* ORDER */}
                                <div className='mb-4'>
                                    <label className='form-label fw-bold'>Numeracija</label>
                                    <Field
                                        name='Numeracija'
                                        type='text'
                                        className='form-control form-control-solid'
                                    />
                                </div>

                                {/* NAZIV */}
                                <div className='mb-4'>
                                    <label className='form-label fw-bold'>Naziv *</label>
                                    <Field
                                        name='Naziv'
                                        className='form-control form-control-solid'
                                    />
                                    <ErrorMessage
                                        name='Naziv'
                                        component='div'
                                        className='text-danger mt-1'
                                    />
                                </div>

                                {/* ENGLISH */}
                                <div className='mb-4'>
                                    <label className='form-label'>Naziv (EN)</label>
                                    <Field
                                        name='NazivEng'
                                        className='form-control form-control-solid'
                                    />
                                    <ErrorMessage
                                        name='NazivEng'
                                        component='div'
                                        className='text-danger mt-1'
                                    />
                                </div>

                                {/* DE */}
                                <div className='mb-4'>
                                    <label className='form-label'>Naziv (DE)</label>
                                    <Field
                                        name='NazivDe'
                                        className='form-control form-control-solid'
                                    />
                                </div>

                                {/* ES */}
                                <div className='mb-4'>
                                    <label className='form-label'>Naziv (ES)</label>
                                    <Field
                                        name='NazivEs'
                                        className='form-control form-control-solid'
                                    />
                                </div>

                                {/* SL */}
                                <div className='mb-4'>
                                    <label className='form-label'>Naziv (SL)</label>
                                    <Field
                                        name='NazivSl'
                                        className='form-control form-control-solid'
                                    />
                                </div>

                                {/* MJERA */}
                                <div className='mb-4'>
                                    <label className='form-label'>Mjera</label>
                                    <Field
                                        name='Mjera'
                                        className='form-control form-control-solid'
                                    />
                                </div>

                                {/* STANDARD */}
                                <div className='mb-4'>
                                    <label className='form-label'>Standard</label>
                                    <Field
                                        name='Standard'
                                        className='form-control form-control-solid'
                                    />
                                </div>

                                {/* ACTIONS */}
                                <div className='d-flex justify-content-end mt-5'>
                                    <button
                                        type='submit'
                                        className='btn btn-primary'
                                        disabled={isSubmitting}
                                    >
                                        {!isSubmitting
                                            ? 'Potvrdi'
                                            : 'Snima se...'}
                                    </button>
                                </div>
                            </Form>

                        </div>

                    )}
                </Formik>
            </div>
        </div>
    )
}

export default DigitalniDopStavkeDetails